const ru = {
  banner: {
    title: 'Похудей с умом',
    subtitle: 'Натуральный жиросжигатель для достижения цели',
    cta: 'Выбрать упаковку',
    slide1: 'Видимый результат за 10 дней',
    slide2: 'Хватит колоть Озэмпик',
    slide3: 'Больше энергии — меньше голода',
  },
  about: {
    title: 'Как это работает',
    description: 'Наши капсулы ускоряют метаболизм и уменьшают аппетит без побочных эффектов.',
    feature1: 'Натуральные ингредиенты',
    feature2: 'Быстрый результат',
    feature3: 'Безопасность и сертификация',
  },
  buy: {
    title: 'Выберите упаковку',
    pack1: '10 капсул',
    pack2: '30 капсул',
    pack3: '100 капсул',
    cta: 'Купить',
  },
  faq: {
    title: 'Вопросы и ответы',
    q1: 'На сколько безопасен препарат?',
    a1: 'Данный медицинский препарат является протестирован и полностью безопасен, при соблюдении дозировок и противопоказаний.',
    q2: 'Как часто нужно принимать лекарство?',
    a2: 'Принимать 1 раз в день, строго натощак, за час до еды с утра. Не рекомендуем принимать во второй половине дня, во избежание сложностей со сном.',
    q3: 'Кто производитель лекарства?',
    a3: 'Производителем и поставщиком медицинского препарата является компания "Lannet", США.',
    q4: 'Где я могу ознакомиться с официальной инструкцией от производителя?',
    a4: 'Вы сможете ознакомиться с инструкцией на сайте производителя.',
    q5: 'Какие будут первые ощущения после употребления капсулы?',
    a5: 'Через 20-30 минут вы почувствуете прилив энергии и избавитесь от чувства голода на длительное время.',
    q6: 'Как происходит оплата и доставка?',
    a6: 'Оплатить вы сможете по банковским реквизитам нашего магазина или же наложенным платежом при получении в любом удобном отделении почтового сервиса.',
    q7: 'Будет ли у меня зависимость от препарата?',
    a7: 'При правильном употреблении дозировки, по инструкции от производителя, после окончания курса лечения никакой зависимости не будет.',
  },  
  contact: {
    title: 'Заказ / Связь',
    name: 'Ваше имя',
    email: 'Ваш e-mail',
    phone: 'Ваш телефон',
    message: 'Сообщение или детали заказа',
    send: 'Отправить',
    success: '✅ Заявка успешно отправлена!',
    error: '❌ Ошибка при отправке. Попробуйте позже.',
    notify: 'Новая заявка с сайта Body Harmony',
  },
  
}

export default ru
